import EstimationProjects from "../Home/EstimationProjects";
import Footer from "../../Common/Footer/Footer";
import Navbar from "../../Nav/Navbar";
import Sidedrawer from "../../Nav/Sidedrawer";
import Loader from "../../Common/Loader";
import React, { useEffect, useState } from "react";
import { estimationData } from "../../Data/Data";

function Estimation({ onToggle, handler, show, backdrop }) {
  const [display, setDisplay] = useState(false);

  useEffect(() => {
    document.title = "Estimation | Dastkaar";
  }, []);
  useEffect(() => {
    setInterval(() => {
      setDisplay(true);
    }, 1500);
  }, []);

  return (
    <div data-lenis-prevent>
      {display === false ? (
        <Loader />
      ) : (
        <>
          <Navbar onToggle={onToggle} handler={handler} />
          <Sidedrawer onToggle={onToggle} show={show} handler={handler} />
          {backdrop}
          <main>
            <EstimationProjects projects={estimationData} />
          </main>
          <Footer />
        </>
      )}
    </div>
  );
}

export default Estimation;
